export class EncodingUtils {
  public static encodeBase64(data: string): string {
    if (data == undefined) {
      return "";
    }

    const bytes = new TextEncoder().encode(data);
    const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("");
    return btoa(binary);
  }

  public static decodeBase64(data: string): string {
    if (data == undefined) {
      return "";
    }

    const binary = atob(data);
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  }
}
